import { render, staticRenderFns } from "./BrigadeFieldEditor.vue?vue&type=template&id=17d1c9ce&"
import script from "./BrigadeFieldEditor.vue?vue&type=script&lang=js&"
export * from "./BrigadeFieldEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCardSection,QItem,QSelect,QIcon,QBanner} from 'quasar'
component.options.components = Object.assign({QCardSection,QItem,QSelect,QIcon,QBanner}, component.options.components || {})
